import { FC } from "react";
import { DocumentsSections } from "../../../../domain/enums/DocumentsSectionsEnum";
import UserAgreementContents from "./UserAgreementContents";
import PaymentSecurityPolicyContents from "./PaymentSecurityPolicyContents";
import CookiePolicyContents from "./CookiePolicyContents";
import PrivacyPolicyContents from "./PrivacyPolicyContents";
import ComplaintAndDisputeResolutionPolicyContents from "./ComplaintAndDisputeResolutionPolicyContents";
import SubscriptionPolicyContents from "./SubscriptionPolicyContents";
import PostingRulesContents from "./PostingRulesContents";
import PublicOfferContents from "./PublicOfferContents";
import languageServiceFactory from "../../../../services/LanguageServiceImpl";

interface DocumentsContentsProps {
    documentsSection: DocumentsSections;
}

const languageService = languageServiceFactory();

const DocumentsContents: FC<DocumentsContentsProps> = (props) => {
    return (
        <div className="relative H16 dmax2:H14 w-[860px] tmax5:w-full text-textWhite">
            {props.documentsSection === DocumentsSections.USER_AGREEMENT ? (
                <UserAgreementContents isEnglish={languageService.isEnglish} />
            ) : props.documentsSection === DocumentsSections.PAYMENT_SECURITY_POLICY ? (
                <PaymentSecurityPolicyContents isEnglish={languageService.isEnglish} />
            ) : props.documentsSection === DocumentsSections.COOKIE_POLICY ? (
                <CookiePolicyContents isEnglish={languageService.isEnglish} />
            ) : props.documentsSection === DocumentsSections.PRIVACY_POLICY ? (
                <PrivacyPolicyContents isEnglish={languageService.isEnglish} />
            ) : props.documentsSection === DocumentsSections.COMPLAINT_AND_DISPUTE_RESOLUTION_POLICY ? (
                <ComplaintAndDisputeResolutionPolicyContents isEnglish={languageService.isEnglish} />
            ) : props.documentsSection === DocumentsSections.SUBSCRIPTION_POLICY ? (
                <SubscriptionPolicyContents isEnglish={languageService.isEnglish} />
            ) : props.documentsSection === DocumentsSections.POSTING_RULES ? (
                <PostingRulesContents isEnglish={languageService.isEnglish} />
            ) : (
                <PublicOfferContents isEnglish={languageService.isEnglish} />
            )}
        </div>
    );
};

export default DocumentsContents;
